import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getClientSideMyLatestSubscriptionWithMop } from '../SubscriptionUtil/clientSide/index';
/**
 * Get the user's subscriptions and method of payment details from the Subscription Util.
 * @param teamName
 * @param apolloClient
 * @returns MyLatestSubscriptionsV1WithMop
 */
export var getSubscriptionsWithMopDetails = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apolloClient, teamName, environment) {
    var _yield$getClientSideM, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getClientSideMyLatestSubscriptionWithMop({
            teamName: teamName,
            apolloClient: apolloClient,
            environment: environment
          });
        case 2:
          _yield$getClientSideM = _context.sent;
          data = _yield$getClientSideM.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSubscriptionsWithMopDetails(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/fetchSubscription.js
// module id = 4158
// module chunks = 11